export default __webpack_public_path__ + "static/media/slide-b.74f94a2b.jpg";